export default __webpack_public_path__ + "files/media/plane-desktop.f5cce152.webp";